import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ToaTagOrders from "./ToaTagOrders";
import {
  getToaTagOrders,uploadTagOrderCsv
} from "services/redux/fasTag/action";

const mapStateToProps = (state) => ({
  toaTagOrders: state.fastagPricingReducer.toaTagOrders
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getToaTagOrders,
      uploadTagOrderCsv
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ToaTagOrders);
